













































import { propOfType } from '@/services/utils';
import Vue from 'vue';
import IconX24 from '@/components/icons/IconX24.vue';

export default Vue.extend({
  props: {
    title: propOfType<string>('Modal'),
    errorMessage: propOfType<string>(''),
    isSmall: propOfType<boolean>(false),
    isExtraSmall: propOfType<boolean>(false),
    onClose: propOfType<Function>(() => {}),
    onConfirm: propOfType<Function>(() => {}),
    showSpinnerInConfirmButton: propOfType<boolean>(false),
    showSpinnerInCancelButton: propOfType<boolean>(false),
    showConfirmButton: propOfType<boolean>(true),
    showCancelButton: propOfType<boolean>(true),
    showCloseButton: propOfType<boolean>(true),
    confirmLabel: propOfType<string>('Aceptar'),
    cancelLabel: propOfType<string>('Cancelar'),
  },
  computed: {
    containerClass(): string {
      if (this.isExtraSmall) return 'w-1/5 xs-modal-container';
      if (this.isSmall) return 'w-1/5 small-modal-container';
      return 'modal-container w-full';
    },
  },
  components: { IconX24 },
});
